










































































































import {
  Component,
  Prop,
  Vue,
  Watch
} from "@/shared/vuepack";
import _ from "lodash";
import { Validator } from "vee-validate";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import {
  HsaAccountDetails,
  InvestmentAccountRepointRequest
} from "@/admin/types";
import {
  UserHsaAccountStatus,
  FetchState
} from "@/shared/types";
import { useNotifierStore } from "@/shared/store/notifier";
import { useInvestmentAccountRepointStore } from "@/admin/store/investmentAccountRepoint";

@Component({
  components: {
    GenericLoadingSpinner
  }
})
export default class RepointInvestmentAccount extends Vue {
  $validator: Validator;
  notifierStore = useNotifierStore();
  investmentAccountRepointStore = useInvestmentAccountRepointStore();

  ssn = "";
  isModalVisible = false;
  requestModel: InvestmentAccountRepointRequest = {
    fromAccount: null,
    toAccount: null
  };

  investmentAccountFields = [
    {
      key: "accountNumber",
      thClass: "text-left"
    },
    {
      key: "accountDescription",
      thClass: "text-left"
    },
    {
      key: "isActive",
      thClass: "text-left"
    },
    {
      key: "currentBalance",
      thClass: "text-left"
    }
  ];

  hsaAccountFields = [
    {
      key: "firstName",
      thClass: "text-left"
    },
    {
      key: "lastName",
      thClass: "text-left"
    },
    {
      key: "employerName",
      thClass: "text-left"
    },
    {
      key: "partnerName",
      thClass: "text-left"
    },
    {
      key: "hsaAccountNumber",
      thClass: "text-left"
    },
    {
      key: "hsaAccountStatus",
      thClass: "text-left"
    },
    {
      key: "investments",
      thClass: "text-left"
    },
    {
      key: "from",
      label: "From",
      thClass: "text-center"
    },
    {
      key: "to",
      label: "To",
      thClass: "text-center"
    }
  ];

  setFromSelectedAccount (hsaAccountDetail: HsaAccountDetails): void {
    if (this.requestModel.fromAccount === hsaAccountDetail.hsaAccountId) {
      this.requestModel.fromAccount = null;

    } else {
      this.requestModel.fromAccount = hsaAccountDetail.hsaAccountId;
    }
  }

  setToSelectedAccount (hsaAccountDetail: HsaAccountDetails): void {
    if (this.requestModel.toAccount === hsaAccountDetail.hsaAccountId) {
      this.requestModel.toAccount = null;

    } else {
      this.requestModel.toAccount = hsaAccountDetail.hsaAccountId;
    }
  }

  @Watch("investmentAccountRepointStore.hsaAccounts", { deep: true })
  accountEligibleToTransferFrom (hsaAccountDetail: HsaAccountDetails): boolean {
    return hsaAccountDetail.investmentFetchState === FetchState.Loaded &&
        hsaAccountDetail.hsaAccountStatus !== UserHsaAccountStatus.NoAccount &&
        hsaAccountDetail.investmentAccounts !== undefined && hsaAccountDetail.investmentAccounts.some(x => x.isActive);
  }

  @Watch("investmentAccountRepointStore.hsaAccounts", { deep: true })
  accountEligibleToTransferTo (hsaAccountDetail: HsaAccountDetails): boolean {
    return  hsaAccountDetail.investmentFetchState === FetchState.Loaded &&
        hsaAccountDetail.hsaAccountStatus === UserHsaAccountStatus.Open &&
      (hsaAccountDetail.investmentAccounts === undefined || !hsaAccountDetail.investmentAccounts.some(x => x.isActive));
  }

  showDetailButton (hsaAccountDetail: HsaAccountDetails): boolean {
    return hsaAccountDetail.hasInvestments;
  }

  showDetailsLoading (hsaAccountDetail: HsaAccountDetails): boolean {
    return hsaAccountDetail.investmentFetchState !== FetchState.Loaded;
  }

  get selectedFromAccount (): HsaAccountDetails {
    return _.find(this.investmentAccountRepointStore.hsaAccounts,
      x => x.hsaAccountId === this.requestModel.fromAccount);
  }

  get selectedToAccount (): HsaAccountDetails {
    return _.find(this.investmentAccountRepointStore.hsaAccounts,
      x => x.hsaAccountId === this.requestModel.toAccount);
  }

  get requestModelValid (): boolean {
    return !!this.requestModel.fromAccount && !!this.requestModel.toAccount;
  }

  openModel (): void {
    this.isModalVisible = true;
  }

  closeModel (): void {
    this.isModalVisible = false;
    this.clearRequestSelections();
  }

  searchHsaUsers (e: Event): void {
    e.preventDefault();
    this.$validator.validateAll()
      .then(isValid => {
        if (this.investmentAccountRepointStore.isLoading || !isValid) {
          return;
        }

        this.investmentAccountRepointStore.getHsaAccounts(this.ssn);
    });
  }

  clearRequestSelections (): void {
    this.requestModel = {
      fromAccount: null,
      toAccount: null
    };
  }

  resetState (): void {
    this.clearRequestSelections();
    this.investmentAccountRepointStore.resetState();
  }

  saveRepointingRequest (e: Event): void {
    e.preventDefault();
    this.$validator.validateAll()
      .then(isValid => {
        if ((!this.requestModel.fromAccount || !this.requestModel.toAccount) || !isValid) {
          return;
        }

        this.investmentAccountRepointStore.saveRepointingRequest(this.requestModel);
        this.closeModel();
    });
  }
}
